import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { MainLayoutService } from 'src/app/services/main-layout.service';

@Component({
  selector: 'app-global-home-page',
  standalone: true,
  imports: [],
  templateUrl: './global-home-page.component.html',
  styleUrl: './global-home-page.component.scss'
})
export class GlobalHomePageComponent implements OnInit, OnDestroy {
  appVersion: any;
  companyCode = '';
  companyName = '';
  logoPath: string | null = null;
  tagline = 'The innovative ERP of Gaming testing and Audit';
  quote = 'A big problem must be broken down into many small problems... After that will be easy to solve them one by one...';
  private subscription = new Subscription();

  constructor(private commonService: CommonService, private mainLayoutService: MainLayoutService, private ngZone: NgZone) { }

  ngOnInit(): void {
    const currentUrl = this.mainLayoutService.getLogoUrl();
    if (currentUrl) this.logoPath = currentUrl;

    this.loadUserFromStorage();
    this.appVersion = this.commonService.getAppVersion();
    this.subscription.add(
      this.mainLayoutService.logoUrl$.subscribe(url => {
        if (url) this.preloadLogo(url);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onLogoError(): void {
    this.logoPath = null;
  }

  private preloadLogo(url: string): void {
    if (url === this.logoPath) return;
    const img = new Image();
    img.onload = () => this.ngZone.run(() => { this.logoPath = url; });
    img.onerror = () => { };
    img.src = url;
  }

  private loadUserFromStorage(): void {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) return;

    try {
      const user = JSON.parse(storedUser);
      this.companyCode = user?.currentUserProfile?.company?.code || '';
      this.companyName = user?.currentUserProfile?.company?.name || '';
    } catch (error) {
      console.error('Error parsing user data from localStorage:', error);
    }
  }
}
